module.exports = __webpack_public_path__ + "static/cv-3ba55c832140c04f10090fdc4b3112b9.pdf";